export function useEnums(props) {
    const Step = {
        AgeAndMarital: "age",
        TypeOfService: "service",
        Accommodation: "accommodation",
        IncomeAndExpenditure: "income",
        Calculation: "calculation",
    };
    const StepLabels = {
        [Step.AgeAndMarital]: "Ålder och civiltillstånd",
        [Step.TypeOfService]: "Typ av tjänst",
        [Step.Accommodation]: "Boendeform",
        [Step.IncomeAndExpenditure]: "Inkomster, utgifter och avgifter",
        [Step.Calculation]: "Summering",
    };
    const TooltipText = {
        'netIncome': 'Nettoinkomst är till exempel inkomst av tjänst eller pension och är beloppet du får ut efter att skatten är dragen.',
        'allowance': 'På Pensionsmyndighetens hemsida kan du göra en preliminär beräkning för att se ditt eventuella bostadstillägg.',
        'capital': 'Överskott av kapital är till exempel räntor eller utdelning. Du hittar beloppet i din senast inskickade deklaration.',
        'assessedValue': 'Skatteverket kan hjälpa dig att ta reda på din fastighets taxeringsvärde om du inte redan känner till det.',
        'interestExpense': 'Räntan du eventuellt betalar på ditt bolån per månad (ej amorteringar).',
        'mealCost': 'Kostnaden för måltiderna är en fast avgift utöver omsorgsavgiften.',
        'reservedAmmount': 'När vi räknar ut vilken avgift du ska betala tar vi hänsyn till att du får behålla en summa som täcker dina normala levnadskostnader. Det kallas för förbehållsbelopp.',
        'rentalCost': 'Utöver avgifter för omsorg och måltider tillkommer hyra för särskilt boende. Hyreskostnaden beror på vilket boende du väljer.',
    };
    const StepNumbers = {
        [Step.AgeAndMarital]: 1,
        [Step.TypeOfService]: 2,
        [Step.Accommodation]: 3,
        [Step.IncomeAndExpenditure]: 4,
        [Step.Calculation]: 5,
    };
    const StepList = [
        Step.AgeAndMarital,
        Step.TypeOfService,
        Step.Accommodation,
        Step.IncomeAndExpenditure,
        Step.Calculation,
    ];
    const ButtonStrings = {
        next: "Fortsätt",
        back: "Tillbaka",
        reset: "Börja om",
    };
    const AgeFee = {
        under: {
            label: "Under 61 år gammal",
            value: 650,
        },
        over: {
            label: "Över 61 år gammal",
            value: 0,
        },
    };
    const ServiceFee = {
        domestic: {
            label: "Hemtjänst",
            value: props.domestic_cost_couple,
            single: props.domestic_cost_single,
            name: "domestic",
        },
        special: {
            label: "Särskilt boende/Äldreboende",
            value: props.special_cost_couple,
            single: props.special_cost_single,
            name: "special",
        },
    };
    const Fees = {
        one: {
            label: props.fee_text.title_level_1,
            value: Math.round(props.max_pay * 0.1),
            text: props.fee_text.level_1,
        },
        two: {
            label: props.fee_text.title_level_2,
            value: Math.round(props.max_pay * 0.15),
            text: props.fee_text.level_2,
        },
        three: {
            label: props.fee_text.title_level_3,
            value: Math.round(props.max_pay * 0.3),
            text: props.fee_text.level_3,
        },
        four: {
            label: props.fee_text.title_level_4,
            value: Math.round(props.max_pay * 0.6),
            text: props.fee_text.level_4,
        },
        five: {
            label: props.fee_text.title_level_5,
            value: Math.round(props.max_pay * 0.8),
            text: props.fee_text.level_5,
        },
        six: {
            label: props.fee_text.title_level_6,
            value: props.max_pay,
            text: props.fee_text.level_6,
        },
    };
    const MaritalStatus = {
        single: {
            label: "Ensamstående",
            value: "single",
        },
        partner: {
            label: "Sambo",
            value: "partner",
        },
        married: {
            label: "Gift",
            value: "married",
        },
    };
    const Accommodation = {
        rent: {
            label: "Hyresrätt",
            value: "rent",
        },
        house: {
            label: "Egen ägd fastighet",
            value: "house",
        },
        apartment: {
            label: "Bostadsrätt",
            value: "apartment",
        },
        special: {
            label: "Särskilt boende/Äldreboende",
            value: "special",
        },
    };
    return {
        Step,
        StepLabels,
        TooltipText,
        StepNumbers,
        StepList,
        ButtonStrings,
        AgeFee,
        ServiceFee,
        Fees,
        MaritalStatus,
        Accommodation,
    };
}
